import React, { useState, useCallback } from 'react';

const gameData = [
  { 
    type: 'video',
    videoId: 'b-RsYBRzvtc',
    name: 'Bladefall',
    description: 'Dive into a dystopian world under siege by rogue AI. Face off against a mysterious doppelganger in this intense action-adventure game that challenges your perception of reality.',
    steamLink: '#',
    thumbnail: '/media/banners/bladefall-banner.jpg',
    videoUrl: 'https://www.youtube.com/watch?v=b-RsYBRzvtc'
  },
  { 
    type: 'image',
    img: '/media/banners/sabotage-banner.jpg',
    name: 'Project: Sabotage',
    description: 'Our most ambitious project yet. A groundbreaking game that will challenge your perception of reality. Coming soon.',
    comingSoon: true
  }
];

function Games() {
  const [imageLoadErrors, setImageLoadErrors] = useState({});

  const handleImageError = useCallback((gameName) => {
    console.error(`Image failed to load for ${gameName}`);
    setImageLoadErrors(prev => ({
      ...prev,
      [gameName]: true
    }));
  }, []);

  const handleGameClick = useCallback((game) => {
    if (game.type === 'video' && game.videoUrl) {
      // Open YouTube video in a new tab
      window.open(game.videoUrl, '_blank');
    }
  }, []);

  return (
    <section id="games" className="games">
      <div className="title">
        <lord-icon
          src="https://cdn.lordicon.com/ibgjiwvi.json"
          trigger="loop"
          colors="primary:#00ffff,secondary:#ffffff"
          style={{width: '50px', height: '50px'}}
        ></lord-icon>
        <h2 className="title-text">Our <span>Games</span></h2>
        <p>Discover our lineup of innovative and immersive gaming experiences</p>
      </div>
      <div className="content">
        {gameData.map((game, index) => (
          <div 
            key={index} 
            className="game-card" 
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="imgBx">
              {game.type === 'video' ? (
                <div
                  className="video-preview-container"
                  onClick={() => handleGameClick(game)}
                  style={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    cursor: 'pointer',
                    backgroundColor: '#000',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    minHeight: '200px'
                  }}
                >
                  <img
                    src={game.thumbnail}
                    alt={`${game.name} preview`}
                    onError={(e) => {
                      console.error(`Failed to load thumbnail: ${e.target.src}`);
                      handleImageError(game.name);
                    }}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'center',
                      backgroundColor: imageLoadErrors[game.name] ? '#333' : '#000'
                    }}
                  />
                  <div 
                    className="video-overlay"
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      background: 'rgba(0,0,0,0.5)',
                      zIndex: 2,
                      cursor: 'pointer'
                    }}
                  >
                    <box-icon 
                      name='play' 
                      type='solid' 
                      color='#ffffff' 
                      style={{width: '50px', height: '50px'}}
                    ></box-icon>
                  </div>
                </div>
              ) : (
                <img
                  src={game.img}
                  alt={game.name}
                  onError={(e) => handleImageError(game.name)}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    backgroundColor: imageLoadErrors[game.name] ? '#333' : '#000'
                  }}
                />
              )}
            </div>
            <div className="game-content">
              <h3>{game.name}</h3>
              <p>{game.description}</p>
              {imageLoadErrors[game.name] && (
                <div style={{color: 'red', marginTop: '10px'}}>
                  Image failed to load. Please check the image path.
                </div>
              )}
              {!game.comingSoon && (
                <a href={game.steamLink} className="steam-btn" target="_blank" rel="noopener noreferrer">
                  <box-icon name='steam' type='logo' color="#ffffff"></box-icon>
                  View on Steam
                </a>
              )}
              {game.comingSoon && (
                <div className="coming-soon">
                  Coming Soon
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Games;
